import React from 'react';
import { ReportBlock } from '../../../../types/report-builder';
import { Card, CardContent } from '../../../ui/card';
import HeaderBlock from './HeaderBlock';
import StatRowBlock from './StatRowBlock';
import ChartBlock from './ChartBlock';
import TableBlock from './TableBlock';
import NarrativeBlock from './NarrativeBlock';
import CalloutBlock from './CalloutBlock';
import SectionHeaderBlock from './SectionHeaderBlock';
import DividerBlock from './DividerBlock';
import MetricComparisonBlock from './MetricComparisonBlock';
import HtmlBlock from './HtmlBlock';

interface Props {
  block: ReportBlock;
}

const hasString = (value: unknown): value is string => typeof value === 'string';
const hasArray = (value: unknown): value is unknown[] => Array.isArray(value);

const BlockRenderer: React.FC<Props> = ({ block }) => {
  switch (block.type) {
    case 'header':
      if (hasString((block as any).title)) {
        return <HeaderBlock block={block as any} />;
      }
      break;
    case 'stat_row':
      if (hasArray((block as any).stats)) {
        return <StatRowBlock block={block as any} />;
      }
      break;
    case 'chart':
      if (hasString((block as any).chartType)) {
        return <ChartBlock block={block as any} />;
      }
      break;
    case 'table':
      if (hasArray((block as any).columns) && hasArray((block as any).rows)) {
        return <TableBlock block={block as any} />;
      }
      break;
    case 'narrative':
      if (hasString((block as any).markdown)) {
        return <NarrativeBlock block={block as any} />;
      }
      break;
    case 'callout':
      if (hasString((block as any).markdown)) {
        return <CalloutBlock block={block as any} />;
      }
      break;
    case 'section_header':
      if (hasString((block as any).title)) {
        return <SectionHeaderBlock block={block as any} />;
      }
      break;
    case 'divider':
      return <DividerBlock />;
    case 'metric_comparison':
      if (hasString((block as any).title) && hasArray((block as any).items)) {
        return <MetricComparisonBlock block={block as any} />;
      }
      break;
    case 'html':
      if (hasString((block as any).html)) {
        return <HtmlBlock block={block as any} />;
      }
      break;
    default:
      break;
  }

  if (hasString((block as any).markdown)) {
    return <NarrativeBlock block={block as any} />;
  }
  if (hasString((block as any).html)) {
    return <HtmlBlock block={block as any} />;
  }

  return (
    <Card className="my-6 border-border/70 bg-card shadow-[var(--shadow-card)]">
      <CardContent className="space-y-2 py-4 text-sm text-muted-foreground">
        <p>
          Custom block: <code>{block.type}</code>
        </p>
        <pre className="overflow-x-auto whitespace-pre-wrap text-xs">
          {JSON.stringify(block, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
};

export default BlockRenderer;
